import { Avatar, Card, Divider, Grid, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import OrderListTable from './components/OrderListTable'
import PageUrls from '../../../../../../constants/page-urls'
import { useUser } from '../../../../../../hooks/useUser'
import { EOrderStatus, IOrder, OrderSummary } from '../../../../../../types/order'
import { PaginationResponseInterface } from '../../../../../../types/pagination'
import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import { UserRole } from '../../../../../../types/user'
import TiktokOrderFilter, { IFilterMapped } from './components/TiktokOrderFilter'
import { orderMock } from '../../../../../../resources/order'
import { OrderMenuSelect } from './components/OrderMenuSelect'
import { Logout, PersonAdd, Settings } from '@mui/icons-material'
import useAxios, { axiosInstance } from '../../../../../../hooks/useAxios'
import { message } from 'antd'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../../constants/errors'

const Menus: any[] = []


const TiktokOrderList = () => {
  const navigate = useNavigate()
  const { merchant, user } = useUser()
  const queryStr = queryString.parse(window.location.search)
  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
  })
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [selectedOrders, setSelectedOrders] = useState<IOrder[]>([])
  // const hasTrackingCodeOrder = selectedOrders.filter(order => order.trackingCode)

  const onFilterChange = useCallback((newFilter: IFilterMapped) => {
    setFilter(newFilter)
  }, [setFilter])

  const handleSearch = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.Marketplace.Shope.Tiktok.Order}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(searchFilter)
  }, [])

  const ordersList = useAxios<PaginationResponseInterface<IOrder> & { total: OrderSummary }>({
    method: 'GET', url: '/order', params: { ...searchFilter, showTotal: "1", platform: "tiktok" },
  })

  const onHandleAddAccount = async () => {
    try {
      const currentUrl = window.location.href
      const response = await axiosInstance.get<{ url: string }>(`/tiktok/login?redir=${currentUrl}&merchant=${merchant.prefix}`)
      setTimeout(() => {
        window.location.href = response.data.url
      }, 1500)
    } catch (e: any) {
      const messageError = ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] || 'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }

  return (
    <ContentWrapper>
      <Helmet title="คำสั่งซื้อจาก Tiktok" />
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item xs={12} md={12} lg={12} >
          <HeaderContent
            goBack
            title="คำสั่งซื้อจาก Tiktok"
            routes={Menus}
            descriptions="คำสั่งซื้อจาก Tiktok"
            tags={
              [UserRole.ADMIN, UserRole.MERCHANT].some(role => (user.roles as UserRole[])?.includes(role)) ||
                merchant.config?.display?.totalOrder ?
                [
                  {
                    title: 'จำนวน',
                    color: 'info',
                    value: ordersList.data?.total?.count ?? 0,
                    classifier: 'ออเดอร์',
                  },
                  {
                    title: 'COD ทั้งหมด',
                    color: 'warning',
                    value: ordersList.data?.total?.codTotal ?? 0,
                    classifier: 'บาท',
                  },
                  {
                    title: 'โอนทั้งหมด',
                    color: 'primary',
                    value: ordersList.data?.total?.bankTotal ?? 0,
                    classifier: 'บาท',
                  },
                  {
                    title: 'ยอดรวม',
                    color: 'warning',
                    value: ((ordersList.data?.total?.bankTotal ?? 0) + (ordersList.data?.total?.codTotal ?? 0)),
                    classifier: 'บาท',
                  },
                  {
                    title: 'จำนวน',
                    color: 'info',
                    value: ordersList.data?.total?.quantity ?? 0,
                    classifier: 'ชิ้น',
                  },
                  // {
                  //   title: 'CODส่งสำเร็จ',
                  //   color: 'primary',
                  //   value: ordersList.data?.total?.codTelesale ?? 0,
                  //   classifier: 'บาท',
                  // },
                  // {
                  //   title: 'COD ระหว่างขนส่ง',
                  //   color: 'warning',
                  //   value: ordersList.data?.total?.codShipping ?? 0,
                  //   classifier: 'บาท',
                  // },
                  // {
                  //   title: 'COD ตีกลับ',
                  //   color: 'error',
                  //   value: ordersList.data?.total?.codReturn ?? 0,
                  //   classifier: 'บาท',
                  // },
                  // {
                  //   title: 'ค้างส่ง',
                  //   color: 'info',
                  //   value: ordersList.data?.total?.pending ?? 0,
                  //   classifier: 'บาท',
                  // },
                ] : undefined
            }
            childrenRight={
              <>
                <IconButton
                  onClick={handleClick}
                  size="small"
                  sx={{ ml: 2 }}
                  aria-controls={open ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                >
                  <Avatar sx={{ width: 48, height: 48 }}>{merchant.tiktok?.sellerName[0]}</Avatar>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  onClick={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      width: 180,
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 1.5,
                      '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  {merchant.tiktok &&
                    <MenuItem onClick={handleClose}>
                      <Avatar />
                      <Typography variant="body2">{merchant.tiktok.sellerName}</Typography>
                      <Logout
                        sx={{ ml: 1 }}
                      />
                    </MenuItem>
                  }
                  <Divider />
                  <MenuItem onClick={onHandleAddAccount}>
                    <ListItemIcon>
                      <PersonAdd fontSize="small" />
                    </ListItemIcon>
                    เพิ่มบัญชี
                  </MenuItem>
                </Menu>
              </>
            }
          />
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}>
        <TiktokOrderFilter
          filter={filter as any}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
        />
        {selectedOrders.length > 0 && <OrderMenuSelect
          isPrint={true}
          isReturn={true}
          onClick={(value: EOrderStatus) => {
            console.log('value', value)
          }}
          total={selectedOrders.length}
        />}
        <OrderListTable
          isLoading={ordersList.isLoading}
          data={ordersList.data?.records ?? []}
          selectedData={selectedOrders}
          setSelectedData={setSelectedOrders}
          filter={filter}
          onFilterChange={handleSearch}
          total={ordersList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>)
}

export default TiktokOrderList
